import { http } from './http';
import type { ApiSuccess } from './types';

export interface UserDto {
  id: number;
  email: string;
  fullName: string;
  isActive: boolean;
  role: { id: number; slug: string; name: string };
}

export const usersApi = {
  async list(): Promise<UserDto[]> {
    const res = await http.get<ApiSuccess<UserDto[]>>('/api/users');
    return res.data.data;
  },

  async create(payload: {
    email: string;
    password: string;
    fullName: string;
    roleId: number;
    isActive?: boolean;
  }): Promise<UserDto> {
    const res = await http.post<ApiSuccess<UserDto>>('/api/users', payload);
    return res.data.data;
  },

  async update(
    id: number,
    payload: Partial<{
      email: string;
      fullName: string;
      roleId: number;
      isActive: boolean;
      password: string;
    }>,
  ): Promise<UserDto> {
    const res = await http.put<ApiSuccess<UserDto>>(`/api/users/${id}`, payload);
    return res.data.data;
  },

  async remove(id: number): Promise<void> {
    await http.delete(`/api/users/${id}`);
  },
};
